export default __webpack_public_path__ + "static/media/warning.82542f3a.svg";